import { axios } from "~/plugins/request"
export const state = () => {
	return {}
}
export const mutations = {}

export const actions = {
  // 获取流程分类
  workflowTreeTypeSearch({ commit }, params) {
		return new Promise((resolve, reject) => {
			axios.get('/workflowTree/workflowTreeTypeSearch', {params})
      .then(response => {
        resolve(response)
      })
      .catch(error => {
        reject(error)
      })
		})
  },
  
  // 查询流程列表
	workflowTreeSearch({ commit }, params) {
		return new Promise((resolve, reject) => {
			axios.post('/workflowTree/workflowTreeSearch', params)
      .then(response => {
        resolve(response)
      })
      .catch(error => {
        reject(error)
      })
		})
  },

  // 保存流程
  workflowTreeSave({ commit }, params) {
    return new Promise((resolve,reject) => {
      axios.post('workflowTree/workflowTreeSave',params)
      .then(response => {
        resolve(response)
      })
      .catch(error => {
        reject(error)
      })
    })
  },

  // 修改流程
  workflowTreeModify({ commit }, params) {
    return new Promise((resolve,reject) => {
      axios.post('workflowTree/workflowTreeModify',params)
      .then(response => {
        resolve(response)
      })
      .catch(error => {
        reject(error)
      })
    })
  },

  // 删除流程
  workflowTreeDelete({ commit },params) {
    return new Promise((resolve,reject) => {
      axios.get('workflowTree/workflowTreeDelete',{params})
      .then(resposen => {
        resolve(resposen)
      })
      .catch(error => {
        reject(error)
      })
    })
  },

  // 获取某流程下的所有节点
  workflowNodeSearch({ commit },params) {
    return new Promise((resolve,reject) => {
      axios.get('workflowNode/workflowNodeSearch',{params})
      .then(resposen => {
        resolve(resposen)
      })
      .catch(error => {
        reject(error)
      })
    })
  },

  // 节点页面获取部门信息
  getDepartment({ commit },params) {
    return new Promise((resolve,reject) => {
      axios.get('workflowNode/workflowNodeFindOrgType',{params})
      .then(resposen => {
        resolve(resposen)
      })
      .catch(error => {
        reject(error)
      })
    })
  },

  // 获取组织架构
  // getDepartmentByParentId({ commit }, params) {
	// 	return new Promise((resolve, reject) => {
  //     // axios.get('/workflowNode/getDepartmentByParentId', {params} )
  //     axios.get('/org/findByParentId', {params} )
	// 			.then(response => {
	// 				resolve(response)
	// 			})
	// 			.catch(error => {
	// 				reject(error)
	// 			})
	// 	})
  // },

  // 节点页面获取岗位信息
  getPost({ commit },params) {
    return new Promise((resolve,reject) => {
      axios.get('dictionary/findAllItemByTypeCode',{params})
      .then(resposen => {
        resolve(resposen)
      })
      .catch(error => {
        reject(error)
      })
    })
  },

  // 保存节点
  workflowNodeSave({ commit },params) {
    return new Promise((resolve,reject) => {
      axios.post('workflowNode/workflowNodeSave',params)
      .then(resposen => {
        resolve(resposen)
      })
      .catch(error => {
        reject(error)
      })
    })
  }
}